import React from 'react';

import { Tooltip } from 'antd';

import { STORE_URL } from 'settings';

function Store() {
  return (
    <Tooltip title='Store' placement='bottom'>
      <a id='topbar-store-link' target='_blank' href={STORE_URL} rel='noopener noreferrer'>
        <img
          className='block w-10 p-2'
          src='/img/icon-store-topbar.svg'
          alt='Ícone de carrinho para a Loja de Apps Eduzz'
        />
      </a>
    </Tooltip>
  );
}

export default Store;
